import {
  FETCH_LATEST_REQUEST,
  FETCH_LATEST_SUCCESS,
  FETCH_LATEST_FAILURE,
} from '../actions';

const defaultLatestState = {
  latest: [],
  loading: false,
  error: false
};

const reducer = (state = defaultLatestState, action) => {
  switch(action.type){
    case FETCH_LATEST_REQUEST:
      return {
        ...state,
        loading: true,
        latestLoaded: false,
      };
    case FETCH_LATEST_SUCCESS:
      return {
        ...state,
        latest: action.page.acf.videos,
        loading: false,
        latestLoaded: true,
      };
    case FETCH_LATEST_FAILURE:
      return {
        ...state,
        loading: false,
        latestLoaded: false,
        error: true
      };
    default:
      return state;
  }
}

export default reducer;
